import React, { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    clientName: "",
    whatsapp: "",
    serviceType: "",
    attachmentPath: null,
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const allowedFileTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/zip", // .zip
    "image/png",
    "image/jpeg",
    "image/jpg",
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Check file type
      if (!allowedFileTypes.includes(file.type)) {
        setStatus("Invalid file type. Only PDF, DOCX, or images are allowed.");
        return;
      } else {
        setStatus("");
      }

      setFormData({ ...formData, [name]: file });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const data = new FormData();
      data.append("ClientName", formData.clientName);
      data.append("Whatsapp", formData.whatsapp);
      data.append("ServiceType", formData.serviceType);
      data.append("Message", formData.message);
      if (formData.attachmentPath)
        data.append("AttachmentPath", formData.attachmentPath);

      const res = await fetch(
        `https://api.mzrsoftware.com/api/SendEmail/send`,
        {
          method: "POST",
          body: data,
        },
      );

      if (res.ok) {
        setStatus("Message sent successfully!");
        setFormData({
          clientName: "",
          whatsapp: "",
          serviceType: "",
          attachmentPath: null,
          message: "",
        });
      } else {
        const error = await res.json();
        setStatus(
          error?.message || "Failed to send message. Please try again.",
        );
      }
    } catch (error) {
      console.error(error);
      setStatus("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <section id="contact" className="py-5 my-7">
      <div className="container">
        <h2 className="text-center fw-bold mb-4">Contact Us</h2>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <form
              className="p-4 border rounded shadow-sm"
              onSubmit={handleSubmit}
            >
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">WhatsApp</label>
                <input
                  type="tel"
                  className="form-control"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Service Type</label>
                <select
                  className="form-select"
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a service</option>
                  <option value="custom-software">
                    Custom Software Development
                  </option>
                  <option value="pos-erp">POS & ERP Systems</option>
                  <option value="web-ecommerce">Web & E-Commerce</option>
                  <option value="cloud-api">Cloud & API Solutions</option>
                  <option value="web">Web Development</option>
                  <option value="desktop">Desktop Applications</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Requirement Attachment</label>
                <input
                  type="file"
                  className="form-control"
                  name="attachmentPath"
                  accept=".pdf,.docx,.zip,image/*"
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Describe Your Requirement</label>
                <textarea
                  rows="4"
                  className="form-control"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button className="btn btn-warning w-100" disabled={loading}>
                {loading ? "Sending..." : "Send Message"}
              </button>

              {status && (
                <p
                  className={`mt-3 text-center ${
                    status.includes("Invalid") ? "text-danger" : "text-success"
                  }`}
                >
                  {status}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
